module.exports = __webpack_public_path__ + "img/search.1a29565b.svg";